import { ELEMENT_IDS } from '@/content/values/ed-presentation-mode.values';

class EdPresentationModeCursor {
    
    public moveParentPointer(data : any, isLoading: boolean, svgElement: HTMLElement) : Promise<boolean> {
        return new Promise((resolve) => {
            if(isLoading){
                return resolve(true);
            }

            let presentationComponent = document.getElementById(ELEMENT_IDS.PRESENTATION_COMPONENT);
            let componentContainer = document.getElementById(ELEMENT_IDS.COMPONENT);
            let pointerY = data.pageY;
            let pointerX = data.pageX;
            
            let componentInfoPosition = presentationComponent.getBoundingClientRect();
            let containerInfoPosition = componentContainer.getBoundingClientRect();
            let topDifference = componentInfoPosition.top - containerInfoPosition.top;
            let leftDifference = componentInfoPosition.left - containerInfoPosition.left;
            
            pointerX = (presentationComponent.offsetWidth * pointerX) / data.teacherWidth;
            pointerY = (presentationComponent.offsetHeight * pointerY) / data.teacherHeight;

            if(!data.homeworksSideBar && !data.zoomObject){
                let pdfContainer : any = document.getElementsByClassName('pdf-container')[0];
                let newPdfContainerWidth = pdfContainer.offsetWidth / 2;
                let newPresentationComponentWidth = presentationComponent.offsetWidth / 2;
                let internalContainerDifference = newPresentationComponentWidth - newPdfContainerWidth;                
                pointerX += internalContainerDifference;
            }

            pointerY += topDifference;
            pointerX += leftDifference;
                            
            svgElement.style.transform = `translate(${pointerX}px, ${pointerY}px)`;
            resolve(true);
        });
    }
}

export default new EdPresentationModeCursor();